import React from 'react';

interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  position?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
  disabled?: boolean;
}

export function Tooltip({ children, content, position = 'right', className = '', disabled = false }: TooltipProps) {
  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
  };

  const arrowClasses = {
    top: 'top-full left-1/2 -translate-x-1/2 border-t-gray-900',
    right: 'right-full top-1/2 -translate-y-1/2 border-r-gray-900',
    bottom: 'bottom-full left-1/2 -translate-x-1/2 border-b-gray-900',
    left: 'left-full top-1/2 -translate-y-1/2 border-l-gray-900',
  };

  return (
    <div className={`group/tooltip relative inline-flex ${className}`}>
      {children}
      {!disabled && (
        <div
          className={`absolute z-[9999] opacity-0 invisible scale-95 group-hover/tooltip:opacity-100 group-hover/tooltip:visible group-hover/tooltip:scale-100 transition-all duration-200 ease-out pointer-events-none ${positionClasses[position]}`}
        >
          <div className="relative w-max max-w-xs min-w-[120px] whitespace-normal rounded-xl bg-gray-900 p-2.5 text-xs font-bold leading-relaxed text-white shadow-xl text-center">
            {content}
            <div className={`absolute border-4 border-transparent ${arrowClasses[position]}`} />
          </div>
        </div>
      )}
    </div>
  );
}
